import React from 'react';

const CartImage = (props) => {
    const { item = {}} = props;
    const { TagPreviewImageFront, TagPreviewImageBack, DisplayImage } = item;

    if(TagPreviewImageFront != null || TagPreviewImageBack != null) {
        return (
            <React.Fragment>
                {TagPreviewImageFront != null && (<a href={window.baseURL + TagPreviewImageFront} data-fancybox><img src={window.baseURL + TagPreviewImageFront} className="photo__img"/></a>)}
                {TagPreviewImageBack != null && (<a href={window.baseURL + TagPreviewImageBack} data-fancybox><img src={window.baseURL + TagPreviewImageBack} className="photo__img"/></a>)}
            </React.Fragment>
        )
    }
    else if (DisplayImage != '') {
        return (
            <a href={window.baseURL + DisplayImage} data-fancybox>
                <img src={window.baseURL + DisplayImage} className="photo__img" />
            </a>
        );
    }
    else {
        return (
            <img src='https://via.placeholder.com/150x150' className="photo__img" />
        );
    }
}

export default CartImage;
